import { useState } from 'react';
import type { FormEvent } from 'react';
import { login } from '../services/api';
import { t } from '../i18n/translations';
import type { Language } from '../i18n/translations';

interface LoginPageProps {
  onLoginSuccess: () => void;
  language?: Language;
}

export default function LoginPage({ onLoginSuccess, language = 'en' }: LoginPageProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError(false);
    setSubmitting(true);
    try {
      const ok = await login(password);
      if (ok) {
        onLoginSuccess();
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
      }}
    >
      <div
        style={{
          background: 'var(--surface)',
          border: '1px solid var(--line)',
          borderRadius: 'var(--radius)',
          padding: '2rem',
          maxWidth: 340,
          width: '90%',
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: '1.4rem', marginBottom: '1rem' }}>{t(language, 'login.title')}</h1>
        <form onSubmit={handleSubmit}>
          <input
            type="password"
            placeholder={t(language, 'login.password')}
            autoFocus
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={submitting}
            style={{
              width: '100%',
              padding: '.65rem .8rem',
              border: '1px solid var(--line)',
              borderRadius: 'var(--radius-sm)',
              fontSize: '1rem',
              marginBottom: '1rem',
              background: 'var(--surface2)',
              color: 'var(--text)',
            }}
          />
          {error && (
            <div
              className="err"
              style={{
                color: 'var(--danger)',
                fontSize: '.875rem',
                marginBottom: '.75rem',
              }}
            >
              {t(language, 'login.error')}
            </div>
          )}
          <button
            type="submit"
            disabled={submitting}
            className="btn btn-primary btn-lg"
          >
            {t(language, 'login.submit')}
          </button>
        </form>
      </div>
    </div>
  );
}
